export const DROPPABLE_ID = "BEAT_SAVER_BROWSER";
